import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsBoxSeam, BsClipboardData, BsTools } from "react-icons/bs";

export default function RapoarteStoc() {
  const navigate = useNavigate();

  return (
    <div className="p-3">
      <Card className="shadow-sm border-0 rounded-4 p-4">
        <h4 className="fw-bold mb-4 text-dark">Rapoarte Stocuri</h4>
        <Row className="g-4">
          <Col xs={12} md={4}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-primary mb-3">
                    <BsBoxSeam size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Situație Stoc Curent</Card.Title>
                  <Card.Text className="text-secondary small">
                    Vizualizează stocul curent de produse, cantitățile disponibile, gestiunea și prețurile de achiziție/vânzare.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/stock/curent")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Stoc Curent
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-info mb-3">
                    <BsClipboardData size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Fișă de Magazie / Mișcări</Card.Title>
                  <Card.Text className="text-secondary small">
                    Urmărește istoricul de intrări și ieșiri ale produselor din depozit și gestiunile active.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/fisa-magazie")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Fișă
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-warning mb-3">
                    <BsTools size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Scăderi Materiale pe Comenzi</Card.Title>
                  <Card.Text className="text-secondary small">
                    Urmărește consumurile și scăderile directe sau prin rețetă realizate pe comenzile interne într-o perioadă selectată.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/scaderi-materiale")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Raport
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
}
